import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

/**
 * Fires POST /api/track/view exactly once per pathname change.
 * Silent: any failure is intentionally ignored so tracking never breaks UX.
 * Skips /admin/* paths so internal editorial usage never inflates public counts.
 */
export default function Tracker() {
  const { pathname } = useLocation();
  const last = useRef(null);

  useEffect(() => {
    if (!pathname) return;
    if (pathname.startsWith("/admin")) return;
    if (last.current === pathname) return;
    last.current = pathname;

    // Fire-and-forget — no await, no error handling needed at call site.
    api
      .post("/track/view", {
        path: pathname,
        referrer: (typeof document !== "undefined" && document.referrer) || "",
      })
      .catch(() => {
        /* tracking failures must never surface */
      });
  }, [pathname]);

  return null;
}
